
import { initializeApp } from "@firebase/app";
import { getDatabase } from "@firebase/database";
import { getAuth } from "@firebase/auth";
import { getStorage } from "@firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyCItcC7QtgWgj1X6u-pnoobBD4ij-9BmHI",
  authDomain: "new-prototype-y48ye.firebaseapp.com",
  projectId: "new-prototype-y48ye",
  storageBucket: "new-prototype-y48ye.firebasestorage.app",
  messagingSenderId: "598896350131",
  appId: "1:598896350131:web:cfcc7b1f2fdd2d3aee31c6"
};

const app = initializeApp(firebaseConfig);
export const db = getDatabase(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
export default app;
